<template>
  <div
    class="invoice-parameter-page">
    <div
      class="d-flex flex-row mt-4">
      <InvoiceParameterFilter
        :parameters="parameters"
      />
    </div>

    <div
      class="d-flex justify-end mt-4">
      <v-btn
        class="font-weight-medium config-button-filter ui-text-base"
        color="primary"
        @click="initParameterConfig"
        v-if="hasPermission('sdi_faturas_conferencia_parametros_configurar')">
        <v-icon
          class="mr-2" color="foreground-accent">
          fas fa-cog
        </v-icon>
        Configuração de Parâmetro
      </v-btn>
    </div>

    <div
      class="my-4 d-flex flex-column">
      <InvoiceParameterTable />
    </div>

    <FullScreenLoader v-if="loadingPage" />

    <SnackbarCustomize ref="InvoiceParameterSnackbar" />
  </div>
</template>

<script>

import InvoiceParameterFilter from '@/components/InvoiceParameters/InvoiceParameterFilter.vue';
import InvoiceParametersMixin from '@/shared/mixins/invoiceParameters/InvoiceParametersMixin';
import InvoiceParameterTable from '@/components/InvoiceParameters/InvoiceParameterTable.vue';
import FullScreenLoader from '@/components/FullScreenLoader/FullScreenLoader.vue';
import SnackbarCustomize from '@/components/CustomAlerts/SnackbarCustomize.vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
  name: "InvoiceParameters",
  components: {
    InvoiceParameterFilter,
    InvoiceParameterTable,
    SnackbarCustomize,
    FullScreenLoader,
  },
  props: {
    parameters: {
      type: Object,
      default: () => {}
    },
  },
  mixins: [
    InvoiceParametersMixin,
  ],
  watch: {
    showSnackbarCustomize: {
      handler(snackbar) {
        if (snackbar.show === true) {
          this.$refs.InvoiceParameterSnackbar.open(
            snackbar.type,
            snackbar.message
          );
        }
      }
    },
  },
  methods: {
    ...mapActions({
      initPage: 'invoice-parameter/initPage',
    }),
    ...mapMutations({
      goToLevelSelection: 'invoice-parameter/goToLevelSelection',
      startCreateConfig: 'invoice-parameter/startCreateConfig',
      startCreating: 'invoice-parameter/startCreating',
      setIsRHProtegido: 'user-info/setIsRHProtegido',
      setAppOrigin: 'user-info/setAppOrigin',
    }),
    initParameterConfig() {
      this.startCreating();
      this.goToLevelSelection();
      this.startCreateConfig();
      this.redirectRouter('InvoiceParameterForm', { isRHProtegido: this.isRHProtegido });
    },
  },
  computed: {
    ...mapGetters({
      showSnackbarCustomize: 'invoice-parameter/showSnackbarCustomize',
      loadingPage: 'invoice-parameter/loadingPage',
      isRHProtegido: 'user-info/isRHProtegido',
      showForm: 'invoice-parameter/showForm',
      appOrigin: 'user-info/appOrigin',
    }),
  },
  async created() {
    const isRHProtegido = this.$route.query.isRHProtegido
      ? this.stringToBoolean(this.$route.query.isRHProtegido.toString())
      : this.appOrigin && this.appOrigin !== 'BACKOFFICE';

    this.setIsRHProtegido(isRHProtegido);
    this.setAppOrigin(isRHProtegido ? 'PROTECTED_HR' : 'BACKOFFICE');

    await this.initPage();
  },
}
</script>
<style lang="scss">
.invoice-parameter-page {
  min-height: calc(100vh - 280px);
}
</style>